import "./DataProtection.module.css";
import Header from "@/reusable_sections/Header";
import Einleitung from "./sections/Einleitung";
import Datenerhebung from "./sections/Datenerhebung";
import Datenverwendung from "./sections/Datenverwendung";
import IhreRechte from "./sections/IhreRechte";
import Kontakt from "./sections/Kontakt";
import Footer from "@/reusable_sections/Footer";
export default function DataProtectionPage() {
  return <div>
      <Header />
      <Einleitung />
      <Datenerhebung />
      <Datenverwendung />
      <IhreRechte />
      <Kontakt />
      <Footer />
    </div>;
}